import React, { Suspense } from "react";

import { SpinnerFullScreen } from "../../components/SpinnerFullScreen";
import GoogleDriveRoute from "./GoogleDriveRoute";

export const GoogleDriveRouteWithLazy: React.FC = () => {
  return (
    <Suspense fallback={<SpinnerFullScreen />}>
      <GoogleDriveRoute />
    </Suspense>
  );
};
